import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, share } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DataSharingService {
  private approvalStageMessage = new BehaviorSubject('');
  currentApprovalStageMessage = this.approvalStageMessage.asObservable();
  private popupConfirmation$ = new BehaviorSubject<any>(null);
  private emailError$ = new BehaviorSubject<any>(null);
  private tanError$ = new BehaviorSubject<any>(null);
  private firstName$ = new BehaviorSubject<any>(null);
  private lastName$ = new BehaviorSubject<any>(null);
  private advisoryNumberError$ = new BehaviorSubject<any>(null);

  private dayFields = new BehaviorSubject('');
  currentDayField = this.dayFields.asObservable();

  updateApprovalMessage(message: string) {
    this.approvalStageMessage.next(message);
  }

  updateApprovalMessage1(message: string) {
    this.dayFields.next(message);
  }

  public setPopupEvent(event: any) {
    this.popupConfirmation$.next(event);
  }

  public getPopupEvent(): Observable<boolean> {
    return this.popupConfirmation$.asObservable().pipe(share());
  }

  public setEmailError(event: any) {
    this.emailError$.next(event);
  }

  public getEmailError(): Observable<any> {
    return this.emailError$.asObservable().pipe(share());
  }

  public setTanError(event: any) {
    this.tanError$.next(event);
  }
  public getTanError(): Observable<any> {
    return this.tanError$.asObservable().pipe(share());
  }

  public setFirstName(event: any) {
    this.firstName$.next(event);
  }
  public getFirstName(): Observable<any> {
    return this.firstName$.asObservable().pipe(share());
  }

  public setLastName(event: any) {
    this.lastName$.next(event);
  }
  public getLastName(): Observable<any> {
    return this.lastName$.asObservable().pipe(share());
  }

  public setAdvisoryNumberError(isError: boolean) {
    this.advisoryNumberError$.next(isError);
  }

  public getAdvisoryNumberError(): Observable<any> {
    return this.advisoryNumberError$.asObservable().pipe(share());
  }
}
